// extracted by mini-css-extract-plugin
export default {"splashScreenContainer":"SplashScreen_splashScreenContainer__0bYXC","fullSize":"SplashScreen_fullSize__GBIlh","splashScreenLogo":"SplashScreen_splashScreenLogo__jMI9g"};